import React from 'react';
import {LoadingCircle} from 'src/shared/components/LoadingCircle';
import {loadingCircle} from 'src/pages/reportIssue/components/styles.module.scss';

export const LoadingScreen = () =>
  <>
    <LoadingCircle className={loadingCircle} />
    <h1>Checking for issues in your area...</h1>
  </>;
